import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-blogs7',
  templateUrl: './section-blogs7.component.html',
  styleUrls: ['./section-blogs7.component.css']
})
export class SectionBlogs7Component implements OnInit {

  @Input() data: any;
  
  constructor() { }

  ngOnInit(): void {
  }

}
